import React from 'react'

interface CardStockProps {
    title?: string;
    total?: number;
    name?: string;
    img?: string;
}

const CardStock = ({ title, name, img, total }: CardStockProps) => {
    return (
        <article className='shadowCard justify-between h-full  p-3 w-full inline-flex gap-3 bg-[#F6F6F6] items-center'>
            <div className="flex-1 min-w-0 gap-3 flex flex-col">
                <p className='title3medium uppercase text-text-blue-200'>{title}</p>
                <div className="flex-1 inline-flex gap-1 items-center">
                    {total && (
                        <p className='h5bold truncate'>{total}</p>
                    )}
                    <p className='title3medium truncate'>{name}</p>

                </div>
            </div>
            {img && (
                <figure className='w-[63px] h-[63px] rounded-[4px] overflow-hidden'>
                    <img src={img} alt={name} loading='eager' className='object-cover w-auto h-auto caption' />
                </figure>

            )}
        </article>
    )
}

export default CardStock
